<template>
  <div id="expert_tab"
       class="main-tab main-tab-o  expert">
    <div class="dv-content">
      <img src="../assets/images/icon_zj_bg.png"
           class="img-ks-bg">
      <img src="../assets/images/icon_zj_bgs.png"
           class="img-zj-bg-bottom">
      <div class="dv-content-s">
        <div class="tv-title">妙手两肩担道义 良医一心为病人</div>
        <div class="dv-content-item">
          <div class="dv-left">
            <div class="tv-ks-title">
              <span @click="onSelect(1)"
                    :class="tagindex == 1 ? 'tv-tag-select' : 'tv-tag-noselect'">本院专家</span><span style="font-size: 12px; color: #707070;margin: 0 10px 0 10px;">|</span>
              <span @click="onSelect(2)"
                    :class="tagindex == 2 ? 'tv-tag-select' : 'tv-tag-noselect'">白衣天使</span>
            </div>

            <div class="ks-lists">
              <el-tree :data="kslist"
                       :props="defaultProps"
                       @node-click="handleNodeClick"
                       :default-expanded-keys="expandedkey"
                       node-key="id"
                       ref="myTree"
                       :current-node-key="currentkey"
                       :highlight-current="true"></el-tree>
            </div>
          </div>
          <div class="dv-rights">
            <div class="tv-ks-names">{{ tagindex == 1 ? '本院专家' : '白衣天使' }}</div>

            <div class="dv-fwbs">

              <div class="dv-doctor-item"
                   v-for="(item,index) in doctorlists"
                   :key="index"
                   @mouseover="MouseOver(index)"
                   @mouseout="Mouseout()"
                   @click="onDetail(item.medicalworkerid)">
                <el-image :src="item.fileUrl"
                          class="img-doctor-head"
                          fit="cover"
                          :class='monindex === index ? "img-doctor-head-big" : ""'></el-image>
                <div class="dv-doctor-content-bg"
                     :class='monindex === index ? "dv-doctor-content-bg-select" : ""'>
                  <div class="tv-doctor-name">{{ item.name }}</div>
                  <div class="tv-zhiwu"><span style="color: #333333;">职务：</span>{{ item.duties }}</div>
                  <div class="tv-zhiwu"><span style="color: #333333;">专业：</span>{{ item.speciality }}</div>
                </div>

              </div>

            </div>
            <div class="dv-fenye">
              <el-pagination background
                             layout="prev, pager, next"
                             prev-text="上一页"
                             next-text="下一页"
                             :page-size='showCount'
                             :total="totalResult"
                             :current-page="currentPage"
                             @current-change="handleCurrentChange">

              </el-pagination>
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible"
               :show-close="false"
               width="25%">
      <div class="dialog-top-bg"
           slot="title">
        <div class="dv-x"
             @click="dialogVisible = false"></div>
      </div>
      <el-image :src="doctor.fileUrl"
                class="img-doctor-heads"
                fit="cover"></el-image>
      <div class="dv-doctor-dialog-content">
        <div class="tv-doctor-names">{{ doctor.name }}</div>
        <div class="dilaog-zhiwu">职务：<span style="color:#767C8B ;">{{ doctor.duties }}</span></div>
        <div class="dilaog-zhiwu">专业：<span style="color:#767C8B ;">{{ doctor.speciality }}</span></div>
        <div class="dilaog-zhiwu">专业方向：<span style="color:#767C8B ;">{{ doctor.major }}</span></div>
        <div class="dilaog-zhiwu">医生简介：<span style="color:#767C8B ;">{{ doctor.introduce }}</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api/api'
const aes = require('../utils/aes.js')
export default {
  data () {
    return {
      tagindex: 1,//1代表本院专家 2代表白衣天使
      expandedkey: [],
      // handleClose: true,
      dialogVisible: false,
      doctorlists: [],
      monindex: 100000,
      currentkey: '',
      checkedkeys: [],
      kslist: [],
      defaultProps: {
        label: 'name',
        children: 'departList',
      },
      showCount: 12,
      totalResult: 0,
      currentPage: 1,
      departid: '',
      doctor: '',//详情
      isdoctor: true,//是否是专家
    }
  },
  props: {
    handleClose: {
      type: Boolean,
      default: true,
    }
  },
  created () {

    if (this.$route.query.isdoctor) {
      this.isdoctor = this.$route.query.isdoctor
      this.tagindex = this.isdoctor == 'true' ? 1 : 2
      console.log('易守难攻' + this.tagindex)
    }

    this.getCategorylist()
  },
  methods: {
    onSelect (e) {
      this.tagindex = e
      this.currentPage = 1
      if (this.tagindex == 1) {
        this.doctorlist(this.departid)
      } else {
        this.nurselist(this.departid)
      }
    },
    MouseOver (index) {
      this.monindex = index
    },
    onDetail (id) {

      if (this.tagindex == 1) {
        this.doctordetail(id)
      } else {
        this.nursedetail(id)
      }
    },
    handleCurrentChange (e) {
      console.log(e)
      this.currentPage = e
      if (this.tagindex == 1) {
        this.doctorlist(this.departid)
      } else {
        this.nurselist(this.departid)
      }

    },
    Mouseout () {
      this.monindex = 100000
    },

    //切换科室
    handleNodeClick (e, data) {
      console.log(data)
      this.currentPage = 1
      //点击的是全部
      if (data.level == 1 && data.data.name == '全部') {
        this.departid = ''
        if (this.tagindex == 1) {
          this.doctorlist(this.departid)
        } else {
          this.nurselist(this.departid)
        }


      } else {
        if (data.level == 2) {
          // console.log("handleNodeClick", e, data);
          this.departid = e.id
          if (this.tagindex == 1) {
            this.doctorlist(this.departid)
          } else {
            this.nurselist(this.departid)
          }
        }
      }




    },
    //获取科室列表
    getCategorylist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 100
      }
      api.departcategorylist(parm).then((res) => {
        var array = res.data.list
        var obj = {}
        obj.id = ''
        obj.name = '全部'
        array.unshift(obj)
        this.kslist = array
        this.departid = ''
        // this.doctorlist(this.departid)
        if (this.tagindex == 1) {
          this.doctorlist(this.departid)
        } else {
          this.nurselist(this.departid)
        }
      })
    },
    //本院专家
    doctorlist (departid) {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,
        departid: departid
      }
      api.doctorlist(parm).then((res) => {
        this.doctorlists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },
    //天使列表
    nurselist (departid) {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,
        departid: departid
      }
      api.nurselist(parm).then((res) => {
        this.doctorlists = res.data.list
        this.totalResult = res.data.page.totalResult


      })
    },
    //专家详情
    doctordetail (medicalworkerid) {
      let parm = {
        FKEY: api.getFKEY(),
        medicalworkerid: aes.Encrypt(medicalworkerid)
      }
      api.doctordetail(parm).then((res) => {
        this.doctor = res.data
        this.dialogVisible = true
      })
    },
    //天使详情
    nursedetail (medicalworkerid) {
      let parm = {
        FKEY: api.getFKEY(),
        medicalworkerid: aes.Encrypt(medicalworkerid),
      }
      api.nursedetail(parm).then((res) => {
        this.doctor = res.data
        this.dialogVisible = true
      })
    },
  }

}
</script>

<style scoped>
.dv-content {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-ks-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-s {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.tv-title {
  font-size: 32px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 50px;
  color: #ffffff;
}
.dv-content-item {
  width: 100%;
  margin-bottom: 200px;
  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
}
.dv-left {
  width: 250px;
  height: 800px;
  display: flex;
  flex-direction: column;
  background: #eff2fa;
}
.dv-rights {
  display: flex;
  width: calc(100% - 300px);
  /* background: white; */
  flex-direction: column;
}
.tv-ks-names {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
  height: 100px;
  padding-left: 50px;
  line-height: 100px;
  background: white;
}
.dv-ks-detail {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px;
  align-items: center;
  background: #edf0f8;
  display: flex;
  flex-direction: row;
  height: 200px;
}
.img-ks {
  width: 300px;
  height: 100%;
}
.dv-ks-details {
  display: flex;
  margin-left: 40px;
  flex-direction: column;
}
.dv-name-item {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  margin-bottom: 20px;
  color: #333333;
}
.tv-ks-title {
  font-size: 22px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  margin-left: 30px;
  margin-top: 20px;
  text-align: left;
  color: #333333;
}
.tv-tag-select {
  text-align: left;
  font-size: 24px;
  color: #333333;
}
.tv-tag-noselect {
  text-align: left;
  font-size: 18px;
  color: #707070;
}
.ks-lists {
  margin-top: 40px;
  overflow: scroll;
  padding-bottom: 40px;
}
.el-tree {
  background: #00000000 !important;
}
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #d2b37c !important;
  color: #ffffff !important;
  padding-left: 30px !important;
}

.el-tree-node__content:hover {
  background: #d2b37c !important;
  /* opacity: 0.5; */
}
.el-tree-node__content {
  height: 60px !important;
  padding-left: 30px !important;
}
.el-tree-node__expand-icon {
  color: #593e2a !important;
}
.is-leaf {
  color: #00000000 !important;
}
.el-tree-node__label {
  font-size: 18px !important;
  color: #593e2a !important;
}

.dv-fwbs {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.view-doctor-content {
  width: 100%;
  height: 350px;
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.dv-doctor-item {
  width: 250px;
  height: 350px;
  position: relative;
  margin: 20px;
}
.img-doctor-head {
  width: 150px;
  height: 150px;
  position: absolute;
  left: calc(50% - 75px);
  border-radius: 180px;
  border: 5px solid #e6eaf5;
  box-sizing: border-box;
  z-index: 2;
}
.img-doctor-heads {
  width: 150px;
  height: 150px;
  border-radius: 180px;
  border: 5px solid #e6eaf5;
}
.dv-doctor-content-bg {
  width: 100%;
  height: 280px;
  position: absolute;
  bottom: 0;
  z-index: 1;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 9px 23.2px 1.8px #e7ebf5;
}
.dv-doctor-content-bg-select {
  border-bottom: 5px #e2c48f solid;
  box-sizing: border-box;
}

.tv-doctor-name {
  font-size: 24px;
  color: #333333;
  margin-top: 90px;
}
.tv-doctor-names {
  font-size: 24px;
  color: #333333;
  margin-bottom: 50px;
  margin-top: 10px;
}
.tv-zhiwu {
  font-size: 18px;
  color: #767c8b;
  margin-top: 20px;
  width: 90%;
  margin-left: 5%;
  text-align: left;
}
.img-doctor-head-big {
  transition: transform 0.3s; /* 添加过渡动画 */
  cursor: pointer; /* 将鼠标指针变为点击状态 */
  transform: scale(1.1);
}
.dilaog-zhiwu {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #282639;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  line-height: 30px;
}
.dv-fenye {
  margin-top: 20px;
  width: 100%;
  height: 60px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #00000000 !important;
}

.img-zj-bg-bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.el-dialog__headerbtn .el-dialog__close,
.el-dialog__headerbtn .el-dialog__close {
  color: #ffd03b !important;
  font-size: 30px !important;
}

.el-icon-close:before {
  content: "\e6db";
  content: "\2713" !important;
}
.dialog-top-bg {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}
.dv-x:before {
  font-size: 25px;
  color: #cccccc;
  content: "\2716";
}
.dv-doctor-dialog-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  max-height: 400px;
}
.el-pagination .btn-next {
  border: 1px solid #beb1e5;
}
</style>
